import { Alert } from '~/components/ui/alert';
import { Button } from '~/components/ui/button';

interface LoadErrorProps {
  /** What failed to load: "placements", "the provider catalog". The title reads "<What> could not be loaded". */
  what: string;
  /** Why, from `apiErrorMessage()`; omit it for the default sentence. Never raw driver or HTTP text. */
  message?: string;
  /** Shows the Try again button. */
  onRetry?: () => void;
  testId?: string;
}

const DEFAULT_MESSAGE =
  'Something went wrong. Try again, or reload the page if it keeps happening.';

/** A persistent load failure, shown in place of what did not load (DESIGN.md §11.2). */
export function LoadError({ what, message = DEFAULT_MESSAGE, onRetry, testId }: LoadErrorProps) {
  return (
    <div data-testid={testId}>
      <Alert
        variant="error"
        title={`${what.charAt(0).toUpperCase()}${what.slice(1)} could not be loaded`}
        message={message}
      >
        {onRetry && (
          <Button
            variant="link"
            onClick={onRetry}
            className="mt-1"
            testId={testId ? `${testId}-retry` : undefined}
          >
            Try again
          </Button>
        )}
      </Alert>
    </div>
  );
}
